module.exports = __webpack_public_path__ + "media/customizations/caymas/back-4133927d21bfbee6b095c7833b887ee6.jpg";